import type { FaireProductEntity } from "../../entity_types/product";

export const p_7406d7o5: FaireProductEntity = {
  token: "p_7406d7o5",
  type: "product",
  name: "Sage thank you greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5b5d7a2baf30cd432c8d78824a25d01dc1a700125a3515b30ae6550ee724ab95/1517921860.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cff5876e4c2d3da414b826cdca323fb86497d084a6b980f0ccffc68e6be5367.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed and foil stamped. 4.25 x 5.5 inches. Illustrated by Marsha Robinson. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n- Each single card comes with an envelope and a cellophane sleeve.\n- Boxed sets are 8 cards with envelopes and are to be sold as packaged, NOT TO BE re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:37.912Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
